import TemplateView from "../../TemplateView";

export default class ButtonSeparator extends TemplateView {

    templateHtml() {
        return "<div class='buttonSeparator'></div>";
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/ButtonSeparator.js